import React from "react"
import ReactDOM from 'react-dom';
import I18n from 'i18n-js';
import '../../translations';
export class HorseResultTable extends React.Component{
  constructor(props) {
    super(props);
  }

  render () {
    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>{I18n.t("wizard.horse_name")}</th>
            <th>{I18n.t("horse.issuing_body")}</th>
            <th>{I18n.t("wizard.owners")} </th>
            <th>{I18n.t("exhibitor.type_of_account")}</th>
            <th>{I18n.t("wizard.exhibitor_account")}</th>
          </tr>
        </thead>
        <tbody>
          {this.props.results.map((result, index) =>
            <tr key={index}>
              <td>{result.name}</td>
              <td>{result.issuing_body}</td>
              <td>{result.horse_recording_number}</td>
              <td>{result.owners}</td>
              <td>{result.exhibitor}</td>
            </tr>
            )
          }
        </tbody>
      </table>
      )
  }
}
